import { computed } from "vue";
import { FormControl } from "@/entities/form-control";
import { useOrdersStore } from "@/stores/orders";
import { FormTab } from "@/entities/form-tab";
import { PickerView } from "@/composables/useDateHelper";

export function useControlRenderer() {
  const ordersStore = useOrdersStore();
  const controls = computed<FormControl[]>(() => ordersStore.getOrderFormControls);

  function showTab(tab: FormTab): boolean {
    if (!tab.showIf?.length) return true

    for (const r of tab.showIf) {
      if (!isControlWithValue(r.id, r.value)) return false
    }

    return true
  }

  function isControlWithValue(controlId: string, value: any): boolean {
    const otherControl = controls.value?.find(c => c.uniqueId === controlId)

    if (
      otherControl?.value?.toString().toLowerCase() ===
      value?.toString().toLowerCase()
    ) {
      return true
    }

    if (value === "" || value == null) {
      if (!otherControl || otherControl.value == null) {
        return true
      }
    }

    return false
  }

  function showControl(control: FormControl): boolean {
    if (!control.showIf?.length) return true

    for (const r of control.showIf) {
      if (!isControlWithValue(r.id, r.value)) return false
    }
    return true
  }

  return {
    controls,
    showTab,
    showControl,
    isControlWithValue,
  };
}

export function useVuetifyDatePickerFix(
  viewMode,
  displayYear
) {
  /**
   * Function to override the broken vuetify 3 date picker behavior from year->date to year->months->date.
   * Vuetify 3.9.x bug:
   *
   * Clicking the current year does not emit update:year, but internally switches the picker from year to month view.
   *
   * We intercept the click in the capture phase and manually switch to the month selection.
   *
   * Can be removed after upgrading Vuetify.
   * @param event
   */
  function onPickerCapture(event: MouseEvent) {
    const button = (event.target as HTMLElement).closest('button')

    if (!(button instanceof HTMLButtonElement))
      return

    if (!isRepeatedYearClick(button))
      return

    event.preventDefault()
    event.stopImmediatePropagation()

    viewMode.value = PickerView.Months
  }

  function isRepeatedYearClick(button: HTMLButtonElement) {
    const container = button.closest('.v-date-picker-years__content')
    if (!container) return false

    const year = Number(button.textContent?.trim())

    return (
      viewMode.value === PickerView.Year &&
      year === displayYear.value
    )
  }

  return {
    onPickerCapture,
  }
}
